export default __webpack_public_path__ + "static/media/uploadImage.4438d378.png";